import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
import * as peristCurrentRole from "../../../../redux/ducks/currentValues.duck";

class Logout extends Component {
  componentDidMount() {
    this.props.logout();
    this.props.clearCurrent();
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  {...auth.actions, ...peristCurrentRole.actions}
)(Logout);
